<!--    CHECK IF ARCHIVE IS EXIST-->
<ng-container *ngrxLet="selectIsRecordRemoved$; let isRecordRemoved">
  <ng-container *ngIf="!isRecordRemoved;else entityRemoved">
    <ng-container *ngrxLet="selectSelectedLocation$;let location">
      <div class="h-100">
        @switch (sharedArchive?.status) {
          @case (archiveStatuses.ERROR) {
            <div class="error-container">
              <span class="ui-icon-warning"></span>
              <div class="description">
                The video has failed to upload. Please contact you person at Lumix.ai
              </div>
              <ui-button type="primary" text="Contact" (click)="openMail()"></ui-button>
            </div>
          }
          @case (archiveStatuses.UPLOADING) {
            <div class="error-container">
              <span class="ui-icon-loading">
              </span>
              <div class="description">
                Video is loading. This might take a few minutes
              </div>
            </div>
          }
          @case (archiveStatuses.COMPLETED) {
            <ui-video-player *ngIf="sharedArchive.videoFormat === ArchiveVideoFormat.MP4" [src]="archiveUrl" [title]="sharedArchive?.name"
                             [timestamp]="sharedArchive.start * 1000"
                             [locationName]="location?.name"
            ></ui-video-player>
            <app-standalone-hls-player *ngIf="sharedArchive.videoFormat === ArchiveVideoFormat.HLS && timelineData?.regularStorage"
              [timelineData]="timelineData" [sharedArchive]="true"
              [title]="sharedArchive?.name"
              [cameraId]="sharedArchive.cameraId"
              [fisheyeEnabled]="true">
            </app-standalone-hls-player>
          }
          @case (archiveStatuses.COMPLETED_TRANSCODE) {
            <app-standalone-hls-player *ngIf="sharedArchive.videoFormat === ArchiveVideoFormat.HLS && timelineData?.regularStorage"
                                       [timelineData]="timelineData" [sharedArchive]="true"
                                       [title]="sharedArchive?.name"
                                       [cameraId]="sharedArchive.cameraId"
                                       [fisheyeEnabled]="true">
            </app-standalone-hls-player>
            <app-standalone-hls-player
              *ngIf="sharedArchive.videoFormat === ArchiveVideoFormat.TimelapseMP4 && timelineData?.regularStorage"
              [title]="sharedArchive?.name"
              [isTimelapse]="true" [sharedArchive]="true"
              [timelapseMetrics]="sharedArchive.files?.videos?.[0]?.timelapseMetrics"
              [duration]="sharedArchive?.timelapse?.duration"
              [timelineData]="timelapseTimelineData"
              [cameraId]="sharedArchive.cameraId"
              [fisheyeEnabled]="true">
            </app-standalone-hls-player>
          }
          @default {
            <app-standalone-hls-player *ngIf="sharedArchive.videoFormat === ArchiveVideoFormat.HLS && timelineData?.regularStorage"
                                       [timelineData]="timelineData" [sharedArchive]="true"
                                       [title]="sharedArchive?.name"
                                       [cameraId]="sharedArchive.cameraId"
                                       [fisheyeEnabled]="true"
                                       [autoPlay]="false" [contain]="true"
            >
            </app-standalone-hls-player>
          }
        }

      </div>
    </ng-container>
  </ng-container>
</ng-container>


<ng-template #entityRemoved>
  <div class="error-container">
    <span class="ui-icon-warning"></span>
    <div class="description">
      The video has failed to upload. Please contact you person at Lumix.ai
    </div>
    <ui-button type="primary" text="Contact" (click)="openMail()"></ui-button>
  </div>
</ng-template>

